import { Badge } from "@/components/shadcn/badge";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/shadcn/table";
import { useFormatter, useTranslations } from "next-intl";
import { RequirementBadge } from "./requirement-badge";

export function CompletedEventsTable({
    title,
    eventColumnLabel,
    rows,
}: {
    title: string;
    eventColumnLabel: string;
    rows: {
        id: number;
        date: Date;
        title: string;
        subtitle: string | null;
        isPremium: boolean;
        capacity: number;
    }[];
}) {
    const t = useTranslations("events");
    const format = useFormatter();

    if (rows.length === 0) return null;

    return (
        <div className="flex min-w-0 flex-col gap-3">
            <h2 className="text-2xl font-medium tracking-tight">{title}</h2>
            <div className="overflow-x-auto">
                <Table className="min-w-md table-fixed">
                    <TableHeader>
                        <TableRow>
                            <TableHead className="w-32">{t("date")}</TableHead>
                            <TableHead>{eventColumnLabel}</TableHead>
                            <TableHead className="w-56 text-center">
                                {t("requirementAndCapacity")}
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody className="bg-background">
                        {rows.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell className="font-medium whitespace-nowrap">
                                    {format.dateTime(
                                        new Date(row.date),
                                        "long",
                                    )}
                                </TableCell>
                                <TableCell>
                                    <div className="flex flex-col gap-0.5">
                                        <span className="line-clamp-1 font-medium">
                                            {row.title}
                                        </span>
                                        {row.subtitle && (
                                            <span className="text-muted-foreground line-clamp-1 text-xs">
                                                {row.subtitle}
                                            </span>
                                        )}
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className="flex items-center justify-center gap-2">
                                        <RequirementBadge
                                            isPremium={row.isPremium}
                                        />
                                        <Badge>
                                            {t("personCount", {
                                                count: row.capacity,
                                            })}
                                        </Badge>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
